// extracted by mini-css-extract-plugin
export default {"create-asset-button":"cPkVvl","light-variant":"JraxQ5"};